export default "https://assets.pclncdn.com/web/next-landing/49d3d019e1/_next/static/images/card-46f5bcb5ad798f1803a957189347cd33.jpg";